import { Box } from "@mui/material"
import { RslS6Settings } from "../SettingsData"
import BaseSettingsDisplay from "./base/BaseSettingsDisplay"
import { useState } from "react"
import TrialTracker from "../../trials/TrialTracker"

const TrialsSettings = () => {

    let setting = RslS6Settings.find(x => x?.name === "Trials")

   let [index, setIndex] = useState(-1) 
   

   console.log("index",index)
    
    return <Box display={"flex"}>
            <BaseSettingsDisplay 
                setting={setting} 
                setIndex={setIndex}

            />
            <Box>
                {index !== -1 && <TrialTracker useRedux={false} useLabel={false} layout="horizontal"/>}  
            </Box>
        </Box>

}

export default TrialsSettings